import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'enrolement',
    loadChildren: () => import('@features/enrollment/enrollment.routes'),
  },
  {
    path: 'reconciliation',
    loadChildren: () => import('@features/reconciliation/reconciliation.routes'),
  },
  {
    path: '',
    redirectTo: 'enrolement',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'enrolement',
  },
];
